/** Shared bits of the Mailing page + its components (form shape, weekday labels, HTML helpers). */
import { BoxTruckMailingDto } from '@numeo/types-main-web-app'

export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const
export const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6]

/**
 * The edit form's state: every field it shares with the record, taken FROM the record's own contract,
 * plus the one field only a form has.
 *
 * Picked rather than re-declared so a rename on the server breaks this at compile time. Every field
 * here is the mailing's own — `message` included, which is the Tiptap HTML the composer produces and
 * the server stores — so writing them out again was a second copy of the same contract, differing only
 * in that `id` is null until the first save.
 *
 * `senderPhoneNumberId` null is the original behaviour and stays the default: the send resolves the
 * creator's own line and falls back to the company's, and Telegram ignores it. `senderPhoneNumber` is
 * what lets the form name a line the caller's own options do not hold, and `createdByMe` says whether
 * "no line named" means the reader's line — on someone else's mailing it does not.
 */
export type MailingFormState = Pick<
    BoxTruckMailingDto,
    'name' | 'timeEST' | 'days' | 'message' | 'driverAccountIds' | 'service' | 'senderPhoneNumberId' | 'senderPhoneNumber' | 'createdByMe'
> & {
    /** Null on a new mailing, the record's id on an edit. */
    id: string | null
}

export const emptyMailingForm = (): MailingFormState => ({
    id: null,
    name: '',
    timeEST: '09:00',
    days: [...ALL_DAYS],
    message: '',
    driverAccountIds: [],
    service: 'telegram',
    senderPhoneNumberId: null,
    senderPhoneNumber: null,
    createdByMe: true,
})
